import React from "react";
import { Modal } from "ui/components";
import { cx } from "utils/join-classnames";
import styles from "./ConfirmActionModal.module.scss";

interface Props {
    title: string;
    description: string;
    handleCancel(): void;
    confirmBtnText: string;
    handleConfirm(): void;
    theme: "light" | "dark";
    pending?: boolean;
}

const ConfirmActionModal: React.FC<Props> = ({
    title,
    description,
    handleCancel,
    confirmBtnText,
    handleConfirm,
    theme,
    pending = false,
}) => {
    const modalContent = (
        <>
            <h2
                className={cx(
                    styles.title,
                    theme === "light"
                        ? styles.title__dark
                        : styles.title__light,
                )}
            >
                {title}
            </h2>
            <p
                className={cx(
                    styles.desc,
                    theme === "light" ? styles.desc__dark : styles.desc__light,
                )}
            >
                {description}
            </p>
        </>
    );
    return (
        <Modal
            content={modalContent}
            lineColor="amber"
            theme={theme}
            onSave={handleConfirm}
            onClose={handleCancel}
            saveButtonText={confirmBtnText}
            saveButtonDisabled={pending}
            fullSize
            title={title}
        />
    );
};

export default ConfirmActionModal;
